import { Component, OnInit, Input, NgZone, ElementRef, Renderer2, Inject } from '@angular/core';
import { environment } from '../../environments/environment';

let SPOTIM_INSTALLED = false;

@Component({
  selector: 'tyt-comments-count',
  templateUrl: './comments-count.component.html',
  styleUrls: ['./comments-count.component.scss']
})
export class CommentsCountComponent implements OnInit {

  constructor(
    private ngZone : NgZone
  ) { }

  _identifier : string = null;

  @Input() 
  get identifier() : string {
    return this._identifier;
  }

  set identifier(value : string) {
    if (this._identifier == value)
      return;

    this._identifier = value;
    this.update();
  }
  
  ngOnInit() {
  }

  async update() {
    if (!this._identifier)
      return;
    
    if (typeof window !== 'undefined') {
      if (!SPOTIM_INSTALLED) {
        this.ngZone.runOutsideAngular(() => {
          SPOTIM_INSTALLED = true;
          setTimeout(() => {
            let el = document.createElement('script');
            el.src = `https://launcher.spot.im/spot/${environment.spotId}?module=messages-count`;
            el.setAttribute('data-spot-id', environment.spotId);
            el.setAttribute('data-spotim-module', 'spotim-launcher');
            el.async = true;
            document.body.appendChild(el);
          }, 1);
        });
      }
    }
  }

}
